module.exports = __webpack_public_path__ + "static/media/Kolibelnaya.1a8502e9.mp3";